// extracted by mini-css-extract-plugin
module.exports = {"messanger":"Massenger_messanger__1AI-Y"};